var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPickUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1666 18.3617L20 18.1117V10.5283L31.9167 10.695L37.1666 18.3617Z",
    fill: "#00BAC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3327 27.862H1.66602V16.9453L20.5827 17.0287V19.1953L3.83266 19.112V25.6953H5.3327V27.862Z",
    fill: "#17104F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3327 27.9447H34.416V25.778H36.166V19.1947H18.916V9.11133H32.5827L38.3327 17.778V27.9447ZM21.0827 17.028H35.2493L31.416 11.278H21.0827V17.028Z",
    fill: "#17104F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2507 31.9447C7.41733 31.9447 5.08398 29.6113 5.08398 26.778C5.08398 23.9446 7.41733 21.6113 10.2507 21.6113C11.584 21.6113 12.9173 22.1113 13.9173 23.1113C14.9173 24.1113 15.4173 25.3613 15.4173 26.778C15.4173 28.1113 14.9173 29.4447 13.9173 30.4447C12.9173 31.4447 11.6673 31.9447 10.2507 31.9447ZM10.2507 23.8613C8.58399 23.8613 7.25068 25.1947 7.25068 26.8613C7.25068 28.528 8.58399 29.8613 10.2507 29.8613C11.084 29.8613 11.7507 29.528 12.334 29.028C12.9173 28.4447 13.1673 27.6947 13.1673 26.9447C13.2507 25.1947 11.9173 23.8613 10.2507 23.8613Z",
    fill: "#17104F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7507 32.0286C26.9173 32.0286 24.584 29.6953 24.584 26.862C24.584 24.0286 26.9173 21.6953 29.7507 21.6953C32.584 21.6953 34.9173 24.0286 34.9173 26.862C34.9173 28.1953 34.4173 29.5286 33.4173 30.5286C32.334 31.4453 31.084 32.0286 29.7507 32.0286ZM29.7507 23.862C28.084 23.862 26.7506 25.1953 26.7506 26.862C26.7506 28.5286 28.084 29.862 29.7507 29.862C31.4173 29.862 32.7506 28.5286 32.7506 26.862C32.6673 25.1953 31.334 23.862 29.7507 23.862Z",
    fill: "#17104F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.12086 12.1029L5.11719 14.2695L7.28383 14.2732L7.28751 12.1066L5.12086 12.1029Z",
    fill: "#17104F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.45639 12.0696L9.45312 14.2363L11.6198 14.2396L11.6231 12.0729L9.45639 12.0696Z",
    fill: "#17104F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.765 12.0609L13.7617 14.2275L15.9284 14.2308L15.9317 12.0642L13.765 12.0609Z",
    fill: "#17104F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8609 25.7503L17.8574 27.917L22.1908 27.9239L22.1942 25.7573L17.8609 25.7503Z",
    fill: "#17104F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickUp);
export default __webpack_public_path__ + "static/media/pick-up.ff73adf9457889c9e4b40499c24a0cf3.svg";
export { ForwardRef as ReactComponent };